<template>
  <div>
    <FullsizeImageModal
      :image-src="previewImage"
      :show="fullsizeImageWasOpened"
      @close="toggleFullsizeImage(false)"
    />
    <div v-if="previewImage" class="mb5">
      <div class="form__image_preview">
        <div
          v-if="previewWasLoaded"
          class="preview-image"
          @click="toggleFullsizeImage"
        >
          <img
            :src="previewImage"
            class="img-responsive"
            ref="previewImageElem"
          />
        </div>
        <div v-else class="preview-image_loading">
          <Preloader type="small" />
        </div>
      </div>
    </div>
    <div v-else class="form__image_unset">Отсутствует</div>
    <FileInput
      v-if="!onlyPreviewImage"
      label="Установить новое изображение"
      accept-types="image/png, image/gif, image/jpeg"
      :without-delete-button="!previewImage"
      @on-delete="$emit('on-delete')"
      @on-select-file="(file) => $emit('on-select-file', file)"
    />
  </div>
</template>

<script>
import Preloader from "@/_shared/components/ui/Preloader";
import FileInput from "@/_shared/components/ui/FileInput";
import FullsizeImageModal from "@/_shared/components/modals/FullsizeImageModal";
export default {
  components: {
    Preloader,
    FileInput,
    FullsizeImageModal,
  },
  props: {
    onlyPreviewImage: {
      type: Boolean,
      default: false,
    },
    previewImage: {
      type: String,
      default: null,
    },
  },
  emits: ["on-select-file", "on-delete"],
  data() {
    return {
      fullsizeImageWasOpened: false,
      previewWasLoaded: true,
    };
  },
  mounted() {
    this.showPreviewImage();
  },
  methods: {
    showPreviewImage() {
      if (this.previewImage) {
        this.previewWasLoaded = false;
      }
      this.$refs.previewImageElem.addEventListener("load", () => {
        this.previewWasLoaded = true;
      });
    },
    toggleFullsizeImage(isOpen = true) {
      if (this.previewWasLoaded) {
        this.fullsizeImageWasOpened = isOpen;
      }
    },
  },
};
</script>

<style scoped>
.preview-image__button_delete {
  margin-bottom: 1em;
}

.form__image_preview {
  display: inline-flex;
  flex-direction: column;
}

.preview-image {
  -webkit-box-shadow: 0px -2px 35px 0px rgba(34, 60, 80, 0.38);
  -moz-box-shadow: 0px -2px 35px 0px rgba(34, 60, 80, 0.38);
  box-shadow: 0px -2px 35px 0px rgba(34, 60, 80, 0.38);
  margin: 1em 0;
  max-width: 10em;
  position: relative;
}

.preview-image_loading {
  width: 10em;
}

.preview-image:hover::after {
  opacity: 0.5;
  transition: 0.3s;
}

.preview-image:hover {
  cursor: pointer;
}

.preview-image::after {
  border-bottom-left-radius: 12px;
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  z-index: 5;
  background-color: rgba(0, 0, 0, 0.6);
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23fff' d='M15,10H12V7a1,1,0,0,0-2,0v3H7a1,1,0,0,0,0,2h3v3a1,1,0,0,0,2,0V12h3a1,1,0,0,0,0-2Zm6.71,10.29L18,16.61A9,9,0,1,0,16.61,18l3.68,3.68a1,1,0,0,0,1.42,0A1,1,0,0,0,21.71,20.29ZM11,18a7,7,0,1,1,7-7A7,7,0,0,1,11,18Z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  width: 40px;
  height: 40px;
}

.preview-image::after:hover {
  cursor: pointer;
  opacity: 0.5;
  transition: 0.3s;
}

.preview-image img {
  width: inherit;
  height: inherit;
  object-fit: cover;
}
.form__image_unset {
  margin-top: 0.5em;
  margin-bottom: 1em;
}

.form__input_image {
  margin-top: 1em;
}
</style>



// WEBPACK FOOTER //
// src/_shared/features/form/ImageInput.vue